export const DEFAULT_MAX_DATE = new Date();
export const DEFAULT_MIN_DATE = new Date(2019, 11, 31);

export const SUNDAY = 0;
export const SATURDAY = 6;
